module.exports = __webpack_public_path__ + "img/yd.cc4e907c.png";